// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { navListLayoutLayout } from "@steiner/App/Widgets/Layout/NavListLayout";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

navListLayoutLayout.container = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 370px) minmax(0, 1fr);
        grid-column-gap: 42px;
        width: 100%;
        background: ${color("common.white")};
        ${xScreen("lte", "md")} {
            grid-column-gap: 0;
            grid-row-gap: 20px;
        }
    `,
};

navListLayoutLayout.navWrapper = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 4;
        display: flex;
        flex-direction: column;
        gap: 24px;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
            grid-row: 2 / 3;
        }
    `,
};

navListLayoutLayout.pageTitleWrapper = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 1 / 2;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
        }
    `,
};

navListLayoutLayout.contentWrapper = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 2 / 3;
        padding-bottom: 20px;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
            grid-row: 3 / 4;
        }
    `,
};
